<template>
    <a-menu
    class="menu-bar"
    v-model="selectedKeys"
    mode="horizontal"
    >
        <template 
        v-for="item in data"
        >
            <a-menu-item
            v-if="!item.children"
            :key="item.id"
            @click="handleClick(item)"
            >
                {{ item.text }}
            </a-menu-item>

            <a-sub-menu
            v-if="item.children"
            :key="item.id"
            >
                <span slot="title">
                    {{ item.text }}

                    <i 
                        class="icon-arrow el-icon-arrow-down"
                    ></i>
                </span>

                <a-menu-item
                v-for="sub in item.children"
                :key="sub.id"
                @click="handleClick(sub)"
                >
                    {{ sub.text }}
                </a-menu-item>
            </a-sub-menu>
        </template>
    </a-menu>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            selectedKeys: [],
        };
    },
    computed: {
        
    },
    created() {
        
    },
    methods: {
        handleClick(item) {
            var children = item.children;

            this.$emit('select', item);
            this.$emit('update:submenu', children || []);
        },
        setActive(id, pid) {
            if (!id) {
                return;
            }

            var navItem = this.data.filter(item => item.id === id)[0];

            if (navItem) {
                this.$emit('update:submenu', navItem.children || []);
            }

            this.selectedKeys = [id];
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../style/menu-bar.css';

.menu-bar {
    border-bottom: none;
    background: transparent;
}
</style>